"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _Button = _interopRequireDefault(require("@material-ui/core/Button"));

var _styledComponents = _interopRequireDefault(require("styled-components"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

const computeStyled = props => {
  if (!props.customPalette) {
    return undefined;
  }

  switch (props.variant) {
    case 'outlined':
      return {
        color: props.customPalette.color,
        backgroundColor: props.customPalette.backgroundColor || 'transparent',
        borderColor: props.customPalette.color,
        hoverColor: props.customPalette.color,
        hoverBackgroundColor: props.customPalette.lightColor,
        hoverBorderColor: props.customPalette.color,
        disabledText: props.customPalette.disabledText,
        disabledBackground: props.customPalette.backgroundColor || 'transparent',
        disabledBorder: props.customPalette.disabledText
      };

    case 'contained':
      return {
        color: props.customPalette.text,
        backgroundColor: props.customPalette.color,
        borderColor: props.customPalette.color,
        hoverColor: props.customPalette.text,
        hoverBackgroundColor: props.customPalette.darkColor,
        hoverBorderColor: props.customPalette.darkColor,
        disabledText: props.customPalette.disabledText,
        disabledBackground: props.customPalette.disabledColor,
        disabledBorder: props.customPalette.disabledColor
      };

    default:
      return {
        color: props.customPalette.color,
        backgroundColor: 'transparent',
        borderColor: 'transparent',
        hoverColor: props.customPalette.color,
        hoverBackgroundColor: props.customPalette.lightColor,
        hoverBorderColor: props.customPalette.color,
        disabledText: props.customPalette.disabledText,
        disabledBackground: 'transparent',
        disabledBorder: 'transparent'
      };
  }
};

const CustomButton = (0, _styledComponents.default)(({
  customPalette,
  children,
  ...props
}) => /*#__PURE__*/_react.default.createElement(_Button.default, props, children))(props => {
  if (!props.customPalette) {
    return null;
  }

  const computeColors = computeStyled(props);
  return {
    '&&': {
      color: computeColors.color,
      backgroundColor: computeColors.backgroundColor,
      borderColor: computeColors.borderColor,
      '&:disabled': {
        color: computeColors.disabledText,
        backgroundColor: computeColors.disabledBackground,
        borderColor: computeColors.disabledBorder
      }
    },
    '&&:hover, &&:focus, &&:active': {
      color: computeColors.hoverColor,
      backgroundColor: computeColors.hoverBackgroundColor,
      borderColor: computeColors.hoverBorderColor
    }
  };
});
CustomButton.propTypes = {
  customPalette: _propTypes.default.shape({
    color: _propTypes.default.string,
    lightColor: _propTypes.default.string,
    darkColor: _propTypes.default.string,
    disabledColor: _propTypes.default.string,
    text: _propTypes.default.string,
    disabledText: _propTypes.default.string,
    backgroundColor: _propTypes.default.string
  })
};
CustomButton.defaultProps = {
  customPalette: null
};
var _default = CustomButton;
exports.default = _default;